export type AysVirtualClinicP21ImportFabSelectionStrategy =
  | 'DURATION'
  | 'LAST_FAB';
export type AysVirtualClinicP21ImportStatus =
  | 'WAITING'
  | 'IN_PROGRESS'
  | 'SUCCESS'
  | 'ERROR';
export type AysFabCreationStrategy = 'DEFAULT_301' | 'FAB_INTERN';

export const AYS_VIRTUAL_CLINIC_P21_IMPORT_FAB_SELECTION_STRATEGY: Record<
  AysVirtualClinicP21ImportFabSelectionStrategy,
  string
> = {
  DURATION: 'Längste Verweildauer',
  LAST_FAB: 'Entlassende Fachabteilung',
};

export const VIRTUAL_CLINIC_KOST_DATA_IMPORT_STATUS: Record<
  AysVirtualClinicP21ImportStatus,
  string
> = {
  WAITING: 'Wartend',
  IN_PROGRESS: 'In Bearbeitung',
  SUCCESS: 'Erfolgreich',
  ERROR: 'Fehlgeschlagen',
};

export const AYS_FAB_CREATION_STRATEGY: Record<AysFabCreationStrategy, string> =
  {
    FAB_INTERN: 'Fab-Intern (§21 Plus)',
    DEFAULT_301: '§301 Fachabteilungszuordnung (Standard)',
  };

/** A KoSt (P21) import as the backend sends it; dates are ISO strings. */
export interface AysVirtualClinicP21ImportResponse {
  id: string;
  originalFileName: string;
  recipientEmailAddress: string;
  fabSelectionStrategy: AysVirtualClinicP21ImportFabSelectionStrategy;
  status: AysVirtualClinicP21ImportStatus;
  virtualClinicId: string;
  blobReference: { containerName: string; fileName: string };
  createdDate: string | null;
  modifiedDate: string | null;
  fabCreationStrategy?: AysFabCreationStrategy | null;
}

export class AysVirtualClinicP21Import {
  public static fromObj(
    obj: AysVirtualClinicP21ImportResponse,
  ): AysVirtualClinicP21Import {
    const modifiedDate = obj.modifiedDate
      ? this.fixUTC(new Date(obj.modifiedDate))
      : null;
    const createdDate = obj.createdDate
      ? this.fixUTC(new Date(obj.createdDate))
      : null;

    return new AysVirtualClinicP21Import(
      obj.id,
      obj.originalFileName,
      obj.recipientEmailAddress,
      obj.fabSelectionStrategy,
      obj.status,
      obj.virtualClinicId,
      obj.blobReference,
      createdDate,
      modifiedDate,
      obj.fabCreationStrategy ?? null,
    );
  }

  private static fixUTC(date: Date): Date {
    date.setHours(date.getHours() + 2);
    return date;
  }

  constructor(
    public id: string,
    public name: string,
    public recipientEmailAddress: string,
    public fabSelectionStrategy: AysVirtualClinicP21ImportFabSelectionStrategy,
    public status: AysVirtualClinicP21ImportStatus,
    public virtualClinicId: string,
    public blobReference: { containerName: string; fileName: string },
    public createdDate: Date,
    public modifiedDate: Date,
    public fabCreationStrategy: AysFabCreationStrategy | null = null,
  ) {}

  clone(): AysVirtualClinicP21Import {
    return new AysVirtualClinicP21Import(
      this.id,
      this.name,
      this.recipientEmailAddress,
      this.fabSelectionStrategy,
      this.status,
      this.virtualClinicId,
      { ...this.blobReference },
      this.createdDate,
      this.modifiedDate,
      this.fabCreationStrategy,
    );
  }
}
